<template>
  <div class="block block_wide">
    <div class="block__item block__intro">
      <div class="block__intro-item block__intro-item_md">
        <div class="grid grid_v-center">
          <div class="grid__col grid__col_stretch">
            <h2>{{ $t('aboutEvent.title') }}</h2>
          </div>
          <div
            class="grid__col grid__col_auto"
            v-if="eventSiteLink"
          >
            <a
              class="link link_light text-with-icon text-sm"
              :href="eventSiteLink"
              target="_blank"
              rel="noopener"
            >
              <icon
                class="icon"
                icon-name="external-link"
                w="16"
                h="16"
              />
              <span>{{ $t('aboutEvent.website') }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="block__intro-item">
        <div
          class="text-content html-content"
          id="eventDescription"
          v-html="description"
        ></div>
      </div>
    </div>
    <div class="block__item block__body" v-if="disciplines && disciplines.length">
      <div class="block__body-item">
        <h3 class="heading-line">
          <span class="heading-line__text">{{ $t('aboutEvent.sportType') }}</span>
        </h3>
      </div>
      <div class="block__body-item">
        <span
          v-for="(item, i) in disciplines"
          :key="item"
        >
          <template v-if="i > 0">• </template>{{ item }}
        </span>
      </div>
    </div>
    <div class="block__item block__body" v-if="showMap">
      <div class="block__body-item">
        <h3 class="heading-line">
          <span class="heading-line__text">{{ $t('aboutEvent.location') }}</span>
        </h3>
      </div>
      <div class="block__body-item">
        <div
          v-show="showMap"
          class="event-location-map"
          id="locationMap"
        ></div>
        <div>{{ place }}</div>
      </div>
    </div>
    <div class="block__item block__body" v-if="program">
      <div class="block__body-item">
        <h3 class="heading-line">
          <span class="heading-line__text">{{ $t('aboutEvent.program') }}</span>
        </h3>
      </div>
      <div class="block__body-item">
        <div
          id="eventProgram"
          class="event-program text-content html-content"
          v-html="program">
        </div>
      </div>
      <photo-viewer
        containerId="eventProgram"
      ></photo-viewer>
    </div>
    <photo-viewer
      containerId="eventDescription"
    ></photo-viewer>
  </div>
</template>

<script>
import PhotoViewer from '@/components/PhotoViewer.vue';
import L from 'leaflet';

export default {
  name: 'EventAbout',
  components: {
    PhotoViewer,
  },
  props: {
    event: Object,
  },
  data() {
    return {
      description: null,
      place: null,
      lat: null,
      lon: null,
      eventSite: null,
      program: null,
      races: null,
    };
  },
  computed: {
    showMap() {
      return false;
      // return this.lat && this.lon;
    },
    eventSiteLink() {
      const site = this.eventSite;
      if (!site) {
        return null;
      }
      if (site.indexOf('http') !== 0) {
        return `http://${site}`;
      }
      return site;
    },
    disciplines() {
      const { races } = this;

      if (!races) {
        return null;
      }

      const disciplines = [];

      for (let i = 0; i < races.length; i += 1) {
        const name = races[i].dn;

        if (disciplines.indexOf(name) === -1) {
          disciplines.push(name);
        }
      }

      return disciplines;
    },
  },
  methods: {
    createMap() {
      if (!this.showMap) {
        return;
      }
      const location = new L.LatLng(this.lat, this.lon);
      const map = L.map('locationMap').setView(location, 13);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        accessToken: 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

      L.marker(location).addTo(map);
    },
    setData() {
      const { event } = this;

      this.description = event.DescriptionHtml;
      this.lat = event.lat;
      this.lon = event.lon;
      this.place = event.Place;
      this.races = event.Races;
      this.eventSite = event.MainLink;
      this.program = event.ProgramHtml;

      this.$nextTick(() => {
        this.createMap();
      });
    },
  },
  mounted() {
    this.setData();
  },
};
</script>

<style lang="scss">
  @import "@/assets/scss/event.scss";

  .event-location-map {
    height: 140px;
    margin-bottom: 16px;
  }
</style>
